import { RandomId } from "@swivl-mono/helpers";
import { NodeInterface } from "@swivl-mono/types";
import { Checkbox } from "@swivl-mono/ui";
import anchorme from "anchorme";
import _ from "lodash";

import { TagInput } from "../../../../Components/TagInput/TagInput";
import VarsModel from "../../../../Models/Variables/VarsModel.Model";
import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import DelayComponent from "../SidePanel/Inspector/components/DelayComponent";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import "./Message.Node.scss";
import NodePanel from "./NodePanel";

const Message = {
  Type: "message",
  Empty: function () {
    return {
      id: RandomId(6),
      type: Message.Type,
      text: "",
      delay: 2,
      showTyping: true,
      onCompleteGoto: null
    };
  },

  PlumbData: function (node: NodeInterface) {
    const text = VarsModel.replaceVariableNameInString(String(node.text), "*", "*");
    const displayText = text.length > 33 ? text.substring(0, 30) + "..." : text;

    return TabNodeLayoutData({
      node: node,
      body: displayText,
      baseWidth: 250,
      tabs: [{ id: "onCompleteGoto", source: "onCompleteGoto", target: node.onCompleteGoto }]
    });
  },

  InspectorPanel: class MessageInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);
      this.onMessageChange = this.onMessageChange.bind(this);
    }

    onMessageChange(e: any) {
      let node = this.props.node;

      _.set(node, "text", e.target.value);
      this.props.updateNode(node, this.props.node);
    }

    render() {
      var urlTarget;
      if (this.props.node && this.props.node.text) {
        const urlList = anchorme.list(this.props.node.text); // NOTE: We need to first check to see if it has any urls because if it does, we need to mark the message as having html
        if (urlList && urlList.length > 0) {
          urlTarget = (
            <div className="urlTarget">
              <span>Open links in new tab</span>
              <Checkbox onCheckedChange={this.onChange} name="openLinksInNewTab" checked={this.props.node.openLinksInNewTab} />
            </div>
          );
        }
      }

      return (
        <div>
          <div className="panel message_panel">
            <InspectorNodeHeader title="Message" />
            <DelayComponent node={this.props.node} onChange={this.onChange} />

            <TagInput value={this.props.node.text} onChange={this.onMessageChange} name="text" helperText="To add a variable, type #" />

            {urlTarget}
          </div>
          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};
export default Message;
